import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var ExclamationIconSvg = "<svg width=\"8\" height=\"8\" viewBox=\"0 0 8 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8 4C8 6.20963 6.20898 8 4 8C1.79102 8 0 6.20963 0 4C0 1.79166 1.79102 0 4 0C6.20898 0 8 1.79166 8 4ZM4 4.80645C3.59024 4.80645 3.25806 5.13863 3.25806 5.54839C3.25806 5.95815 3.59024 6.29032 4 6.29032C4.40976 6.29032 4.74194 5.95815 4.74194 5.54839C4.74194 5.13863 4.40976 4.80645 4 4.80645ZM3.2956 2.13958L3.41524 4.33313C3.42084 4.43577 3.50571 4.51613 3.6085 4.51613H4.3915C4.49429 4.51613 4.57916 4.43577 4.58476 4.33313L4.7044 2.13958C4.71045 2.02871 4.62218 1.93548 4.51115 1.93548H3.48884C3.37781 1.93548 3.28955 2.02871 3.2956 2.13958Z\" fill=\"#EC6B58\"/>\n</svg>\n";

var TwExclamationIconSvg = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M12 21.5C17.5228 21.5 22 17.0228 22 11.5C22 5.97715 17.5228 1.5 12 1.5C6.47715 1.5 2 5.97715 2 11.5C2 17.0228 6.47715 21.5 12 21.5Z\" stroke=\"#CB3939\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M12 7.5V11.5\" stroke=\"#CB3939\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M12 15.5H12.01\" stroke=\"#CB3939\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n";

var ExclamationIcon = window.btoa(ExclamationIconSvg);
var TwExclamationIcon = window.btoa(TwExclamationIconSvg);
var FormInlineError = function FormInlineError(_a) {
  var children = _a.children;
  var errorClassNames = classNames("flex items-start", getIconClasses());
  var textClassNames = "ml-sm text-xs text-danger leading-125 tw:text-sm tw:text-tw-danger-500 tw:leading-150";
  return /*#__PURE__*/React.createElement("span", {
    className: errorClassNames,
    style: getInlineStyles(),
    "data-testid": "form-error"
  }, /*#__PURE__*/React.createElement("span", {
    className: textClassNames
  }, children));
};
function getInlineStyles() {
  return {
    "--exclamation-icon-url": "url('data:image/svg+xml;base64,".concat(ExclamationIcon, "')"),
    "--tw-exclamation-icon-url": "url('data:image/svg+xml;base64,".concat(TwExclamationIcon, "')")
  };
}
function getIconClasses() {
  return ["bg-[image:var(--exclamation-icon-url)] tw:bg-[image:var(--tw-exclamation-icon-url)]", "bg-no-repeat", "bg-[top_0.25rem_left_0] tw:bg-[top_0.125rem_left_0]", "bg-[length:0.5rem_0.5rem] tw:bg-[length:18px_18px]", "pl-[0.5rem] tw:pl-[1.125rem]"];
}
FormInlineError.propTypes = {
  children: PropTypes.node.isRequired
};

export { FormInlineError };
//# sourceMappingURL=index.es.js.map
